/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { conjDependencies } from './dependenciesConj.generated';
import { transposeDependencies } from './dependenciesTranspose.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createCtranspose } from '../../factoriesAny.js';
export var ctransposeDependencies = {
  conjDependencies: conjDependencies,
  transposeDependencies: transposeDependencies,
  typedDependencies: typedDependencies,
  createCtranspose: createCtranspose
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesCtranspose.generated.js
// module id = 1520
// module chunks = 0